import { useCallback, useMemo } from 'react'
import { useRestaurant } from '@/context/RestaurantContext'
import { formatCurrency, getCurrencySymbol } from '@/lib/utils'

/**
 * Currency for owner-facing screens tracks the currently selected
 * restaurant's country (defaulting to the first restaurant, then INR, for the
 * combined "all restaurants" view or before a restaurant has loaded).
 */
export function useCurrency() {
  const { currentRestaurant, restaurants } = useRestaurant()
  const currencyCode = currentRestaurant?.currency || restaurants[0]?.currency || 'INR'

  const format = useCallback((amount: number) => formatCurrency(amount, currencyCode), [currencyCode])
  const currencySymbol = useMemo(() => getCurrencySymbol(currencyCode), [currencyCode])

  return { currencyCode, currencySymbol, formatCurrency: format }
}
